import React from 'react';
import { Routes, Route } from "react-router-dom";
import store from "./lib/redux/Store";
import { PrivateRoutes } from "./lib/hoc/PrivateRoutes";
import { Provider } from 'react-redux';
import { useSelector, useDispatch } from 'react-redux';
import Home from './views/home';
import Login from './views/login';
import Monitoring from './views/monitoring';
import NewTask from './views/newTask';
import SelectedTask from './views/selectedTask/selectedTask';
import TaskForward from './views/taskForward';



const App = () => {
  return (
    <Provider store={store}>
      <Routes>
        {/* Default route */}
        <Route path="/" element={<PrivateRoutes><Home /></PrivateRoutes>} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<PrivateRoutes><Home /></PrivateRoutes>} />
        <Route path="/monitoring" element={<PrivateRoutes><Monitoring /></PrivateRoutes>} />
        <Route path="/new-task" element={<PrivateRoutes><NewTask /></PrivateRoutes>} />
        <Route path="/task/:id" element={<PrivateRoutes><SelectedTask /></PrivateRoutes>} />
        <Route path="/task/:id/forward" element={<PrivateRoutes><TaskForward /></PrivateRoutes>} />
        <Route path="/logout" element={<Logout />} />
        {/* <Route path="/ReportInner" element={<PrivateRoutes><ReportInner /></PrivateRoutes>} /> */}
      </Routes>
    </Provider>
  );
};

const Logout = () => {
  localStorage.removeItem('auth_token')

  window.location.href = '/'
}

export default App;
